<template>
    <b-modal title="Грамматика" size="xl" v-model="opts.show" @ok="opts.show = false">
        <b-row class="mb-1">
            <b-col>
                <div>{{compiledgr}}</div>
            </b-col>
        </b-row>
        <b-row class="mb-5">
            <b-col>
              <b-button v-if="compiledgr.length>0" @click="clearGrammar">очистить</b-button>
            </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              label="Parts of speech"
              label-for="GrammSpeechParts"
              horizontal>
              <b-form-checkbox-group 
                stacked 
                buttons 
                id="GrammSpeechParts" 
                v-model="filter.gr.partOfSpeech" 
                :options="grammararydata.partOfSpeech">
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label="Lexical classes"
              label-for="GrammLexicalClasses"
              horizontal>
              <b-form-checkbox-group 
                stacked 
                buttons 
                id="GrammLexicalClasses" 
                v-model="filter.gr.lexicalClasses" 
                :options="grammararydata.lexicalClasses">
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label="Attributivizers"
              label-for="GrammAttributivizers"
              horizontal>
              <b-form-checkbox-group 
                stacked 
                buttons 
                id="GrammAttributivizers" 
                v-model="filter.gr.attributivizers" 
                :options="grammararydata.attributivizers">
              </b-form-checkbox-group>
            </b-form-group>

            <b-form-group
              label="Numerals"
              label-for="GrammNumerals"
              horizontal>
              <b-form-checkbox-group 
                stacked 
                buttons 
                id="GrammNumerals" 
                v-model="filter.gr.numerals" 
                :options="grammararydata.numerals">
              </b-form-checkbox-group>
            </b-form-group>

            <b-form-group
              label="Number"
              label-for="GrammNumber"
              horizontal>
              <b-form-checkbox-group 
                stacked 
                buttons 
                id="GrammNumber" 
                v-model="filter.gr.number" 
                :options="grammararydata.number">
              </b-form-checkbox-group>
            </b-form-group>

          </b-col>

          <b-col>
          
            <b-form-group
              label="Core cases"
              label-for="GrammCoreCases"
              horizontal>
              <b-form-checkbox-group 
                stacked 
                buttons 
                id="GrammCoreCases" 
                v-model="filter.gr.coreCases" 
                :options="grammararydata.coreCases">
              </b-form-checkbox-group>
            </b-form-group>

         </b-col>

          <b-col>
            <b-form-group
              label="Spatial cases"
              label-for="GrammSpatialCases"
              horizontal>
              <b-form-checkbox-group 
                stacked 
                buttons 
                id="GrammSpatialCases" 
                v-model="filter.gr.spatialCases" 
                :options="grammararydata.spatialCases">
              </b-form-checkbox-group>
              <hr/>
              <b-form-checkbox-group 
                stacked 
                buttons 
                id="GrammSpatialCases2" 
                v-model="filter.gr.spatialCases2" 
                :options="grammararydata.spatialCases2">
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group
              label="Possessiveness"
              label-for="GrammPossessiveness"
              horizontal>
              <b-form-checkbox-group 
                stacked 
                buttons 
                id="GrammPossessiveness" 
                v-model="filter.gr.possessiveness" 
                :options="grammararydata.possessiveness">
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group
              label="Tense/Mood"
              label-for="GrammTense_Mood"
              horizontal>
              <b-form-checkbox-group 
                stacked 
                buttons 
                id="GrammTense_Mood" 
                v-model="filter.gr.tense_mood" 
                :options="grammararydata.tense_mood">
              </b-form-checkbox-group>
            </b-form-group>

            <b-form-group
              label="Verbal derivation"
              label-for="GrammVerbalDerivation"
              horizontal>
              <b-form-checkbox-group 
                stacked 
                buttons 
                id="GrammVerbalDerivation" 
                v-model="filter.gr.verbalDerivation" 
                :options="grammararydata.verbalDerivation">
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>

          <b-col>
              <b-form-group
                label="Non-finite forms"
                label-for="GrammNonFiniteForms"
                horizontal>
                <b-form-checkbox-group 
                  stacked 
                  buttons 
                  id="GrammNonFiniteForms" 
                  v-model="filter.gr.nonFiniteForms" 
                  :options="grammararydata.nonFiniteForms">
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>

            <b-col>
              <b-form-group
                label="Imperatives"
                label-for="GrammImperatives"
                horizontal>
                <b-form-checkbox-group 
                  stacked 
                  buttons 
                  id="GrammImperatives" 
                  v-model="filter.gr.imperatives" 
                  :options="grammararydata.imperatives">
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
      </b-row>
    </b-modal>
</template>

<script>
export default {
  name: "grammarwindow",
  mounted() {
  },
  computed:{
    compiledgr(){
      let out = '';
      if (this.filter.gr.partOfSpeech.length == 0 
        && this.filter.gr.lexicalClasses.length == 0
        && this.filter.gr.numerals.length == 0
        && this.filter.gr.attributivizers.length == 0
        && this.filter.gr.number.length == 0
        && this.filter.gr.coreCases.length == 0
        && this.filter.gr.spatialCases.length == 0
        && this.filter.gr.spatialCases2.length == 0
        && this.filter.gr.possessiveness.length == 0
        && this.filter.gr.tense_mood.length == 0
        && this.filter.gr.verbalDerivation.length == 0
        && this.filter.gr.nonFiniteForms.length == 0
        && this.filter.gr.imperatives.length == 0) out = 'Грамматика не выбрана'
      else {
        if (this.filter.gr.partOfSpeech.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.partOfSpeech) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }
        if (this.filter.gr.lexicalClasses.length != 0 || this.filter.gr.numerals.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.lexicalClasses) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          
          for (let sp of this.filter.gr.numerals) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }
        if (this.filter.gr.attributivizers.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.attributivizers) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }
        if (this.filter.gr.number.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.number) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }
        if (this.filter.gr.coreCases.length != 0 || this.filter.gr.spatialCases.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.coreCases) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          for (let sp of this.filter.gr.spatialCases) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }
        if (this.filter.gr.spatialCases2.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.spatialCases2) {
            if (grr.length != 0) grr += ','
            grr+=sp;
          }
          out += grr;
        }
        if (this.filter.gr.possessiveness.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.possessiveness) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }
        if (this.filter.gr.tense_mood.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.tense_mood) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }
        if (this.filter.gr.verbalDerivation.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.verbalDerivation) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }
        if (this.filter.gr.nonFiniteForms.length != 0 || this.filter.gr.imperatives.length != 0) {
          if (out.trim().length != 0) out += ','
          let grr = '';
          for (let sp of this.filter.gr.nonFiniteForms) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          for (let sp of this.filter.gr.imperatives) {
            if (grr.length != 0) grr += '|'
            grr+=sp;
          }
          if (grr.indexOf('|')>-1) out += '('+grr+')';
          else out += grr;
        }
      }
      this.filter.compiledgr = out;
      return out;
    }
  },
  methods: {
    clearGrammar(){
      this.filter.gr.partOfSpeech = [];
      this.filter.gr.lexicalClasses = [];
      this.filter.gr.attributivizers = [];
      this.filter.gr.numerals = [];
      this.filter.gr.number = [];
      this.filter.gr.coreCases = [];
      this.filter.gr.spatialCases = [];
      this.filter.gr.spatialCases2 = [];
      this.filter.gr.possessiveness = [];
      this.filter.gr.tense_mood = [];
      this.filter.gr.verbalDerivation = [];
      this.filter.gr.nonFiniteForms = [];
      this.filter.gr.imperatives = [];
    }
  },
  props: {
      opts: {
          type: Object,
          default: null
      },
      filter: {
          type: Object,
          default: null
      }
  },
  data(){
    return {
      grammararydata:{
        partOfSpeech: ['N','V','ADJ','ADV','PRED','NUM','PRO','POST','CNJ','PART','INTRJ','IMIT'],
        lexicalClasses:['rel_n','PN','topn','persn','famn','patrn','anim','hum','supernat','transport','body','rel_adj','rus','oblin','I','II','tr','intr'],
        attributivizers:['attr','attr_o','attr_em','attr_tem'],
        numerals:['ord','period','coll'],
        number:['sg','pl'],
        coreCases:['nom','acc','gen','abl','dat','ins','car','adv'],
        spatialCases:['loc','ill','el','egr','term','prol','app'],
        spatialCases2:['obl','case_comp'],
        possessiveness:['1sg','1pl','2sg','2pl','3sg','3pl'],
        tense_mood:['prs','fut','pst','evid','subj'],
        verbalDerivation:['iter','caus','pass','mult','vn'],
        nonFiniteForms:['inf','ptcp','ptcp,act','ptcp,pass','ptcp,res','cvb','cvb,gen','cvb,dur','cvb,lim','cvb,simult'],
        imperatives:['imp','ptcp,act']
      }
    }
  }
}
</script>